import { useCallback, useRef, useState } from 'react'
import { Check } from 'lucide-react'
import { cn } from '@/lib/utils'

/** CopyableId — click to copy with brief checkmark feedback */
export function CopyableId({ id }: { id: string }) {
  const [copied, setCopied] = useState(false)
  const timerRef = useRef<ReturnType<typeof setTimeout>>(undefined)

  const handleCopy = useCallback(() => {
    navigator.clipboard.writeText(id)
    setCopied(true)
    clearTimeout(timerRef.current)
    timerRef.current = setTimeout(() => setCopied(false), 1500)
  }, [id])

  return (
    <div className="flex items-center justify-between mb-1.5">
      <span className="text-muted-foreground text-[10px]">ID</span>
      <button
        type="button"
        className={cn(
          'inline-flex items-center gap-1 font-mono text-[11px] truncate max-w-[160px] transition-colors cursor-copy',
          copied ? 'text-success' : 'text-foreground/70 hover:text-foreground',
        )}
        title="Click to copy ID"
        onClick={handleCopy}
      >
        {copied && <Check className="h-3 w-3 shrink-0" />}
        {copied ? 'Copied!' : id}
      </button>
    </div>
  )
}
